// Combineert partner-record met deeplink-input tot initiële module-keuze
// + lijst van locked modules (mogen niet door gebruiker worden gewijzigd).
//
//   - Partner met `fixedPackage` (TOSS): pakket-modules aan, ALLE 4 modules locked
//     in `mode='strict'` (onboarding-flow — partner dicteert volledig).
//     In `mode='admin'` (NewProjectModal — partner-admin maakt sub-projects)
//     zijn er GEEN locks: partner-modules zijn slechts pre-selected en
//     iedere checkbox blijft aanpasbaar. Deeplink-modules genegeerd — partner wint.
//   - Partner met `freeIncludedModules` (FIX): default-pakket aan +
//     vrije modules locked-aan. In admin-mode geen locks. Deeplink-modules toegevoegd.
//   - Geen partner: deeplink bepaalt. `baseEnabled=true` zet `impactMeten` aan.

const ALL_MODULES = ['impactMeten', 'personas', 'housevisits', 'portfolio']

const emptyModules = () => ({
    impactMeten: false,
    personas: false,
    housevisits: false,
    portfolio: false,
})

const applyPartnerContext = ({ partner = null, deeplink = {}, mode = 'strict' } = {}) => {

    const { moduleSlugs = [], baseEnabled = true } = deeplink

    if (partner?.fixedPackage) {
        const initialModules = emptyModules()
        partner.fixedPackage.modules.forEach((slug) => {
            initialModules[slug] = true
        })
        // freeIncludedModules ook pre-checken — die zijn gratis bij het pakket
        // (bv. FIX = housevisits-pakket + personas gratis erbij).
        const freeModules = partner.freeIncludedModules || []
        freeModules.forEach((slug) => {
            initialModules[slug] = true
        })
        return {
            initialModules,
            lockedModules: mode === 'admin' ? [] : [...ALL_MODULES],
        }
    }

    if (partner?.packages) {
        const initialModules = emptyModules()
        const freeModules = partner.freeIncludedModules || []

        if (moduleSlugs.length === 0 && baseEnabled) {
            const defaultPackage = partner.packages[0]
            if (defaultPackage) {
                defaultPackage.modules.forEach((slug) => {
                    initialModules[slug] = true
                })
            }
        } else {
            moduleSlugs.forEach((slug) => {
                initialModules[slug] = true
            })
        }

        freeModules.forEach((slug) => {
            initialModules[slug] = true
        })

        return {
            initialModules,
            lockedModules: mode === 'admin' ? [] : [...freeModules],
        }
    }

    const initialModules = emptyModules()
    if (baseEnabled) initialModules.impactMeten = true
    moduleSlugs.forEach((slug) => {
        initialModules[slug] = true
    })

    return {
        initialModules,
        lockedModules: [],
    }

}

export default applyPartnerContext
